import React, { useCallback, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from '@mui/material';
import { ApiService } from 'api';
import { manageApiRequest } from 'hooks/apiRequest';
import { shortDate } from 'utilities';
import { OnSendFunction, SendFileDialogProps } from './types';

const SendFileDialog: React.FC<SendFileDialogProps> = ({ measurementDates, open, onClose, file, files }) => {
  const [selectedDate, setSelectedDate] = useState<number | null>(null);

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedDate(Number(event.target.value));
  };

  const sendFileHandler = useCallback<OnSendFunction>(
    async (ref, measurementDateId) => {
      manageApiRequest(
        ApiService.apiDocumentsReferenceCreate(
          measurementDateId.toString(),
          ref.file?.id?.toString() as string,
          {}
        )
      );
      onClose();
    },
    [onClose]
  );

  const handleSave = () => {
    if (selectedDate !== null) {
      if (file) {
        sendFileHandler(file, selectedDate);
      } else if (files) {
        files.forEach(f => sendFileHandler(f, selectedDate));
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Select Measurement Date</DialogTitle>
      <DialogContent>
        <TextField select label="Measurement Date" value={selectedDate ?? ''} onChange={handleDateChange} fullWidth>
          {measurementDates.map(date => {
            if (date.id == null) {
              return null;
            }

            return (
              <MenuItem key={date.id} value={date.id}>
                {shortDate(date.date)}
              </MenuItem>
            );
          })}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary" disabled={selectedDate === null}>
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendFileDialog;
